import useAudio from './useAudio';

const AudioManager = () => {
    useAudio();
    return null;
};

export default AudioManager;
